export default new Promise((res) => {
  const script = document.createElement('script');
  script.onload = () => res();
  script.setAttribute('src', 'https://api.mapbox.com/search-js/v1.0.0-beta.13/web.js');
  document.head.appendChild(script);
});
